// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options as ClientOptions,
  type TDataShape,
  type Client,
  formDataBodySerializer,
} from "@hey-api/client-fetch";
import type {
  ProcessLoanProcessLoanPostData,
  ProcessLoanProcessLoanPostResponse,
  ProcessLoanProcessLoanPostError,
  PostAnswerAnswerPostData,
  PostAnswerAnswerPostResponse,
  PostAnswerAnswerPostError,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Process loan file with streaming
 * Lance le processus VesselLoanFlow à partir d’un fichier PDF et d’un loanId, avec une réponse streamée en JSON.
 */
export const processLoanProcessLoanPost = <ThrowOnError extends boolean = false>(
  options: Options<ProcessLoanProcessLoanPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ProcessLoanProcessLoanPostResponse,
    ProcessLoanProcessLoanPostError,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        in: "query",
        name: "api-key",
        type: "apiKey",
      },
      {
        name: "x-api-key",
        type: "apiKey",
      },
    ],
    url: "/process-loan",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });
};

/**
 * Enregistre une réponse utilisateur
 * Prend une réponse à une question extraite automatiquement et la retourne sous forme de texte.
 */
export const postAnswerAnswerPost = <ThrowOnError extends boolean = false>(
  options: Options<PostAnswerAnswerPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostAnswerAnswerPostResponse,
    PostAnswerAnswerPostError,
    ThrowOnError
  >({
    security: [
      {
        in: "query",
        name: "api-key",
        type: "apiKey",
      },
      {
        name: "x-api-key",
        type: "apiKey",
      },
    ],
    url: "/answer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};
